import { render } from "./ProfileMenu.vue?vue&type=template&id=00867963"
import script from "./ProfileMenu.vue?vue&type=script&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&lang=js"
script.render = render

export default script